import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { GridCell } from '../../../models/sections-model';

@Component({
  selector: 'kw-product-gallery',
  templateUrl: './product-gallery.component.html',
  styleUrls: ['./product-gallery.component.scss']
})
export class ProductGalleryComponent implements OnChanges,AfterViewInit {
  @Input() gridCell:GridCell;
  numberOfImages:number;

  carouselWidth:number;
  track:HTMLElement;
  prev:HTMLElement;
  next:HTMLElement;
  thumbNav:HTMLElement;
  thumbNailWrappers:HTMLElement[] = [];

  carouselPosition  = 0;

  @ViewChild('collectionSlider') collectionSlider:ElementRef<HTMLElement>
  @ViewChild('track') trackHost:ElementRef<HTMLElement>
  @ViewChild('next') nextHost:ElementRef<HTMLElement>
  @ViewChild('prev') prevHost:ElementRef<HTMLElement>
  @ViewChild('thumbNav') thumbHost:ElementRef<HTMLElement>
  
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes["gridCell"]){
      this.numberOfImages = this.gridCell?.contentElements.length;
    }
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    if(this.collectionSlider != null && this.collectionSlider != undefined){
      const hostEle = this.collectionSlider.nativeElement;
      this.carouselWidth = hostEle.offsetWidth;
      this.track = this.trackHost.nativeElement;
      this.next = this.nextHost.nativeElement;
      this.prev = this.prevHost.nativeElement;
      this.thumbNav = this.thumbHost.nativeElement;
      if(this.thumbNav != null && this.thumbNav != undefined){
        for(let i = 0; i < this.thumbNav.children.length; i++){
          this.thumbNailWrappers.push(<HTMLElement>this.thumbNav.children[i])
        }
        /* setTimeout(()=>{ 
          this.setActiveThumbNail();
        }, 600); */
        /* console.log({FirstChild:this.thumbNav.children[0]})
        console.log(this.thumbNav.childNodes);*/

      let firstChild = <HTMLElement> this.thumbNav.children[0];
       firstChild?.classList.add('active');
       console.log({ThumbNailWrappers:this.thumbNailWrappers}); 
      }
    }
  }
  slideLeft():void{
    this.carouselPosition = this.carouselPosition+this.carouselWidth; 
    //console.log({NextPressed:{position:this.carouselPosition}});
    this.prev.classList.add("show");
    this.track.style.transform = "translateX(-"+this.carouselPosition+"px)";

    /* if(this.track.offsetWidth -  this.carouselPosition < this.carouselWidth+1){
      this.next.classList.add("hide");
    } */
    this.toggleArrows();
    this.setActiveThumbNail();
  }
  slideRight():void{
    this.carouselPosition = this.carouselPosition-this.carouselWidth;
    //console.log({PrevPressed:{position:this.carouselPosition}});
    this.next.classList.remove("hide");
    /* if(this.carouselPosition == 0){
      this.prev.classList.remove('show');
    } */
    this.track.style.transform = "translateX(-"+this.carouselPosition+"px)";
    this.toggleArrows();
    this.setActiveThumbNail();
  }

  setActiveThumbNail(){
    //console.log("setActiveThumbNail")
    this.thumbNailWrappers.forEach(thumbNailWrapper => {
      console.log("Removing active");
      if(thumbNailWrapper.classList != undefined && thumbNailWrapper.classList.contains('active')){
        console.log("Found element for to remove class from");
        thumbNailWrapper.classList.remove('active')
      }
    });
    //console.log({CarouselPosition:this.carouselPosition});
    if(this.carouselPosition == 0){
      this.thumbNailWrappers[0].classList.add('active');
    }else{
      let activeIndex = this.carouselPosition/this.carouselWidth;
      this.thumbNailWrappers[activeIndex].classList.add('active');
    }
    
    
  }

  selectThumbNail(i){
    let relation = this.carouselPosition/this.carouselWidth;
    if(relation != i){
      this.carouselPosition = this.carouselWidth*i;
      this.track.style.transform = "translateX(-"+this.carouselPosition+"px)";
      this.setActiveThumbNail();
      if(i == 0){
        this.prev.classList.remove('show');
        this.next.classList.remove("hide");
      }
      if(i == (this.thumbNailWrappers.length-1)){
        this.next.classList.add("hide");
      }
      if(i > 0){
        this.prev.classList.add("show");
        if(i < (this.thumbNailWrappers.length-1)){
          this.next.classList.remove("hide");
        }
      }
    }
    
    /* if(this.carouselPosition/this.carouselWidth != i){

    } */
    //console.log({selectedImage:i,position:this.carouselPosition,Relation:this.carouselPosition/this.carouselWidth});
  }

  toggleArrows(){
    if(this.carouselPosition == 0){
      this.prev.classList.remove('show');
    }
    if(this.track.offsetWidth -  this.carouselPosition < this.carouselWidth+1){
      this.next.classList.add("hide");
    }
  }

}
